// app.session.started state for this page. Module level, not component state: the shell that
// mounts useSessionTracking (BaseIndex) unmounts on routes outside it (settings, new space,
// onboarding), and a remount must not start a session. Kept in its own module so
// analytics.logout can end the session without importing the hook.
export type SessionState = {
  // The user `load` was sent for in this page. A different user identifying in the same tab
  // gets a load of their own.
  loadedUserId: string | null;
  // The user whose `load` waits for a tab opened in the background to be first viewed.
  pendingLoadUserId: string | null;
  // When the last session.started was sent from this page, or null before `load`.
  lastStartedAt: number | null;
  hiddenAt: number | null;
  organizationId: number | undefined;
};

export const session: SessionState = {
  loadedUserId: null,
  pendingLoadUserId: null,
  lastStartedAt: null,
  hiddenAt: null,
  organizationId: undefined,
};

// Ends the session: the next identified user, the same one after a re-login included, gets a
// new `load`.
export const resetSessionState = () => {
  session.loadedUserId = null;
  session.pendingLoadUserId = null;
  session.lastStartedAt = null;
  session.hiddenAt = null;
  session.organizationId = undefined;
};
